export default function ContactInfo() {
  return (
    <section className="py-24 bg-deep-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Address */}
          <div className="bg-forest-green rounded-2xl p-8 text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-copper/10 rounded-full mx-auto mb-6">
              <i className="ri-map-pin-line text-copper text-2xl"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-3">Visit Us</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              1321 S Bay St<br />
              Eustis, FL 32726<br />
              United States
            </p>
          </div>

          {/* Phone & Email */}
          <div className="bg-forest-green rounded-2xl p-8 text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-copper/10 rounded-full mx-auto mb-6">
              <i className="ri-phone-line text-copper text-2xl"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-3">Contact Us</h3>
            <a
              href="tel:+13529774832"
              className="text-gray-300 hover:text-copper transition-colors duration-200 text-sm block mb-2 cursor-pointer"
            >
              +1 352 977-4832
            </a>
            <a
              href="mailto:Highstandards.smokes@gmail.com"
              className="text-gray-300 hover:text-copper transition-colors duration-200 text-sm block cursor-pointer"
            >
              Highstandards.smokes@gmail.com
            </a>
          </div>

          {/* Hours */}
          <div className="bg-forest-green rounded-2xl p-8 text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-copper/10 rounded-full mx-auto mb-6">
              <i className="ri-time-line text-copper text-2xl"></i>
            </div>
            <h3 className="text-white font-semibold text-lg mb-3">Business Hours</h3>
            <ul className="text-gray-300 text-sm space-y-1">
              <li>Monday - Thursday: 8am-10pm</li>
              <li>Friday - Saturday: 8am-11pm</li>
              <li>Sunday: 9am-10pm</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
